import { SupportPanelState } from '@/layouts/CatalogLayout'
import { TemplatesV2 } from './TemplatesV2/TemplatesV2'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { MAIN_HEADER_HEIGHT, PAGE_HEADER_HEIGHT } from '../config'
import { FaqV2 } from './FaqV2/FaqV2'
import { GlossaryV2 } from './GlossaryV2/GlossaryV2'
import { DataAssetsV2 } from './DataAssetsV2/DataAssetsV2'
import { motion } from 'motion/react'
function RenderPanel({ supportPanelView, setSupportPanelView }: SupportPanelState) {
  switch (supportPanelView?.key) {
    case 'data-assets':
      // return <DataAssets supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
      return <DataAssetsV2 />
    case 'data-templates':
      return <TemplatesV2 />
    case 'glossary':
      return <GlossaryV2 />
    case 'faq':
      return <FaqV2 />
    default:
      return <div>Support Pane Key not supported</div>
  }
}

export function SupportPanelComponentRenderer({ supportPanelView, setSupportPanelView }: SupportPanelState) {
  return (
    <ScrollArea
      className="relative"
      style={{ height: `calc(100vh - ${MAIN_HEADER_HEIGHT * 2 + PAGE_HEADER_HEIGHT}px)` }}
    >
      <motion.div layout className="relative">
        <RenderPanel supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView} />
      </motion.div>
    </ScrollArea>
  )
}
